import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1996db5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-symbols-outlined searchIcon" }



export default /*#__PURE__*/_defineComponent({
  __name: 'IconBtn',
  props: ['name'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.name), 1))
}
}

})